// extracted by css-extract-rspack-plugin
export default {"cls1":"LettersModal-cls1_HUX","cls2":"LettersModal-cls2_YPy LettersModal-cls1_HUX"};